import React from 'react'
import CTA from './CTA'
import myPhoto from "../../assets/formal.jpg"
import HeaderSocials from './HeaderSocials'
import "./styles.css"
const Header = () => {
  return (
    <header>
        <div className="container header__container">
            <h5>Hello I'm</h5>
            <h1>Harshvardhan Ravishanker</h1>
            <h3 className="text-light">Programmer | Developer</h3>
            <CTA/>
            {/* <HeaderSocials/> */}
            <div className="me">
                <img src={myPhoto} alt="me" />
            </div>
            < a href='#contact' className='scroll__down'>Scroll Down</a>
        </div>
    </header>
  )
}

export default Header